import ComponentName from '@Constant/componentName'
import { NAV_TAB } from '@Constant/behaviorTrack'
const list = [
  {
    component: () => import('../../views/layout/Index.vue'),
    path: '/popularList',
    children: [
      {
        component: () => import('../../views/popularList/Index.vue'),
        path: 'index',
        name: ComponentName.list.index,
        auth: '*',
        meta: {
          title: '榜单首页',
          logAuto: {
            pv: true,
            duration: true,
            source: NAV_TAB.POPULAR_LIST
          }
        }
      }
    ]
  }
]

export default list
